import React from "react"
import { useNavShell } from "@stjeans/shared-frontend/nav"

export default function FooterItem({ label, Icon, onClick }) {
  const { closeSidebar, isCollapsed } = useNavShell()

  return (
    <button
      type="button"
      onClick={() => {
        onClick?.()
        closeSidebar()
      }}
      className={
        "btn text-white w-100 d-flex align-items-center border-0 " +
        (isCollapsed ? "justify-content-center " : "")
      }
      style={{
        fontSize: "0.875rem",
        fontWeight: 500,
        padding: isCollapsed ? "0.5rem 0.5rem" : "0.75rem 1rem",
        borderRadius: "0.5rem",
        opacity: 0.95,
      }}
      title={isCollapsed ? label : ""}
    >
      <Icon size={isCollapsed ? 24 : 20} />
      <span className={"nav-text" + (isCollapsed ? "" : " ms-2")}>{label}</span>
    </button>
  )
}